
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fixtures-and-results",
      function () {
        return require("private-next-pages/fixtures-and-results.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fixtures-and-results"])
      });
    }
  